import React, { useState, useEffect } from "react";
import { Input, Spin, Modal } from "antd";
import { useSelector } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import moment from "moment";
import { PlusOutlined } from "@ant-design/icons";

// Reusing platform theme styles and components
import "../../Reuseable/NormalButton/NormalButton.scss";
import NormalButton from "../../Reuseable/NormalButton/NormalButton";
import "../PortfolioPage/PortfolioPage.scss";
import "../../components/PortfolioComp/PortfolioCards/PortfolioCards.scss";
import "../../components/PortfolioComp/PortfolioModal/PortfolioModal.scss";

const CompanyPage = () => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newCompany, setNewCompany] = useState("");
  const [adding, setAdding] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { token } = useSelector((state) => state.auth);

  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const response = await axios.get("portfolio/companies/", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data?.data;
      if (data && Array.isArray(data?.companies)) {
        setCompanies(data?.companies);
      } else {
        setCompanies([]);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch companies");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchCompanies();
    }
  }, [token]);

  const handleAddCompany = async () => {
    if (!newCompany.trim()) return;
    setAdding(true);
    try {
      const response = await axios.post(
        "portfolio/companies/",
        { name: newCompany },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200 || response.status === 201) {
        toast.success("Company added successfully");
        setNewCompany("");
        setIsModalOpen(false);
        fetchCompanies();
      } else {
        toast.error("Failed to add company");
      }
    } catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.message || "Failed to add company");
    } finally {
      setAdding(false);
    }
  };

  return (
    <div className="portfolioPageMainWrapper">
      <div className="portfolioPageMain">
        <div className="portfolioPageMainHeader">All Companies</div>
        <div className="portfolioPageMainSegment" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <NormalButton
            className="addPortfolioBtn"
            onClick={() => setIsModalOpen(true)}
            type="primary"
            suffixIcon={<PlusOutlined />}
          >
            Add Company
          </NormalButton>
        </div>
      </div>

      <Modal
        className="modalMainContainer"
        title="Create New Company"
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setNewCompany("");
        }}
        footer={null}
        centered
      >
        <div className="mainWrapperForModal">
          <div style={{ paddingTop: "10px" }}>
            <Input
              placeholder="Enter new company name..."
              value={newCompany}
              onChange={(e) => setNewCompany(e.target.value)}
              onPressEnter={handleAddCompany}
              style={{ borderRadius: "8px", height: "44px", padding: "12px 15px", border: "1px solid #d5dfea" }}
            />
          </div>
          <div className="submitBtn">
            <NormalButton
              type="primary"
              onClick={handleAddCompany}
              loading={adding}
              style={{ maxWidth: "150px" }}
            >
              Create
            </NormalButton>
          </div>
        </div>
      </Modal>

      <div className="portfolioContent">
        <div className="portfolio-cart">
          <div className="portfolioCardsMain">
            {loading ? (
              <div style={{ gridColumn: "1 / -1", textAlign: "center", padding: "50px" }}>
                <Spin size="large" />
              </div>
            ) : companies.length === 0 ? (
              <p className="noDataText" style={{ gridColumn: "1 / -1" }}>
                No companies available.
              </p>
            ) : (
              companies.map((item, index) => {
                const date = item.created_at ? moment(item.created_at).format("DD MMM YYYY") : "-";
                return (
                  <div className="portfolioCardBox" key={index}>
                    <div className="cardHeader">
                      <div className="portfolioNumber">
                        <h2>{item.name || "Unnamed Company"}</h2>
                      </div>
                      <div className="addedOnDate">
                        <p>
                          Added on <span>{date}</span>
                        </p>
                      </div>
                    </div>
                    <div className="cardDetailedInfo">
                      <div className="loanData">
                        <p className="title">Portfolio Count</p>
                        <p className="titleData">{item.portfolio_count || 0}</p>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyPage;
